import i18next from 'i18next'
import moment from 'moment'

export const parseTimestamp = (timestamp: string | number): Date => {
  if (typeof timestamp === 'number') {
    return new Date(timestamp < 10000000000 ? timestamp * 1000 : timestamp)
  }
  
  const date = new Date(timestamp)
  if (!isNaN(date.getTime())) {
    return date
  }
  
  const numTimestamp = Number(timestamp)
  if (!isNaN(numTimestamp)) {
    return new Date(numTimestamp < 10000000000 ? numTimestamp * 1000 : numTimestamp)
  }
  
  return new Date()
}

export const formatTimeDisplay = (date: Date): string => {
  const dayIndex = date.getDay()
  const dayKey = `kpis_widgets.days.${dayIndex}`
  const dayName = i18next.t(dayKey)
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  
  return `${dayName} ${hours}:${minutes}`
}

export const formatDateForTooltip = (date: Date): string => {
  return moment(date).format('DD/MM/YYYY HH:mm')
}